/* eslint-disable indent */
<template>
    <div class="container">
      <div class="dotest">
        <div class="left">象棋{{levelexam}}考试</div>
        <div class="right">考试剩余时间：<span class="time">{{countDownMinute}}:{{countDownSecond}}</span></div>
      </div>
      <div class="dotest_content">
        <div class="item_left">
          <div class="info">
            <div class="item_title">考生信息</div>
            <div class="item_info">考生姓名：{{name}}</div>
            <div class="item_info">考试时间：{{levelexam==='十三级'?'30':'45'}}分钟</div>
             <div class="item_info" style="color:#EF0404">考试内容：{{levelexam==='十三级'?'两步连将杀':'杀法进阶'}}</div>
            <div class="item_info">考试题数：{{questionNum}}</div>
            <div class="item_info">通过标准：12/20</div>
            <!-- <div class="item_info">共<span class="question">{{total}}</span>题/答对<span class="success">{{success}}</span>题</div> -->
            <!-- <div class="item_info">满分100分，60分及格</div> -->
          </div>
          <div class="select" >
            <div class="item_choose" v-for="(item,index) in walkingEnrollItemBanks" :key="index"
                 :class="index === testIndex ? 'item_chooses' :''"
                 :style="index < testIndex ? 'background-color: #999;border: 1px solid #999;color: #fff;' : ''">{{index + 1}}</div>
                 <!-- <div class="submit" @click="submit()">提交</div> -->
          </div>
        </div>
        <div class="item-rigts">
          <cet-go-chess
            v-if="isShow"
            :go-chess="walkingEnrollItemBanks"
            :select-sum="selectsum"
            @gochessnum="pgochessnum"
            @gochestest="pgochestest">
          </cet-go-chess>
        </div>
      </div>
    </div>
</template>

<script>
import {getWalkingEnrollItemBank, updateEnrollFractionById} from '../../api/index'
import cetGoChess from '../../components/cetGoChess'
// 参数：x坐标，y坐标，哪边下子，判断是红棋还是黑棋，判断棋名字
// eslint-disable-next-line no-unused-vars
let descClick
// 记录棋子点击次数
// let clickNumber
export default {
  components: { cetGoChess },
  name: 'gochess',
  data () {
    return {
      totalSecond: 0,
      countDownDay: 0,
      countDownHour: 0,
      countDownMinute: 0,
      countDownSecond: 0,
      name: '',
      levelexam: '',
      testId: '',
      exchangCode: '',
      gradId: '',
      questionNum: 0,
      selectsum: 0,
      walkingEnrollItemBanks: [],
      Chess: [],
      answerChess: [],
      blackChess: [],
      total: 0,
      testIndex: 0, // 题目索引
      clickNumber: 0,
      canGoChess: true,
      banMa: true,
      banXiang: true,
      existe: true,
      faceState: false,
      rX: 0,
      rY: 0,
      hX: 0,
      hY: 0,
      chessGoNumber: 0,
      quesionNumber: 0,
      eatChess: false,
      isError: [],
      redanswerlength: 0,
      success: 0,
      isTrue: true,
      isShow: false
    }
  },
  created () {
    this.name = this.$route.params.name
    this.levelexam = this.$route.params.levelexam
    this.testId = this.$route.params.id
    this.exchangCode = this.$route.params.exchangCode
    this.gradId = this.$route.params.testId
    this.getTest(this.testId, this.exchangCode)
    let studentInfo = {
      name: this.name,
      levelexam: this.levelexam,
      gradId: this.gradId,
      exchangCode: this.exchangCode,
      testId: this.testId
    }
    console.log(this.$route, this.name, this.levelexam, this.testId, this.exchangCode)
    localStorage.setItem('studentInfo', JSON.stringify(studentInfo))
    if (this.levelexam === '十三级') {
      this.totalSecond = 1800
    } else {
      this.totalSecond = 2700
    }
    this.questionNum = 20
    // var totalSecond = 1800
    var interval = setInterval(function () {
      // 秒数
      var second = this.totalSecond
      // 天数位
      var day = Math.floor(second / 3600 / 24)
      var dayStr = day.toString()
      if (dayStr.length === 1) dayStr = '0' + dayStr
      // 小时位
      var hr = Math.floor((second - day * 3600 * 24) / 3600)
      var hrStr = hr.toString()
      if (hrStr.length === 1) hrStr = '0' + hrStr
      // 分钟位
      var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60)
      var minStr = min.toString()
      if (minStr.length === 1) minStr = '0' + minStr
      // 秒位
      var sec = second - day * 3600 * 24 - hr * 3600 - min * 60
      var secStr = sec.toString()
      if (secStr.length === 1) secStr = '0' + secStr
      this.countDownDay = dayStr
      this.countDownHour = hrStr
      this.countDownMinute = minStr
      this.countDownSecond = secStr
      this.totalSecond--
      if (this.totalSecond === 300) {
        this.$message('距离考试结束还剩5分钟')
      }
      if (this.totalSecond < 0) {
        clearInterval(interval)
        // 提交答案
        // 跳转页面
        console.log('时间到', this.success)
        // let totalNumber = this.success * 5
        this.updateEnrollFractionById(this.success)
      }
    }.bind(this), 1000)
  },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
    window.addEventListener('beforeunload', this.unload)
    // window.addEventListener('beforeunload', e => this.unload) // 注册一个匿名函数

    // // 当调整窗口大小时重绘canvas
    // window.onresize = () => {
    //   this.initCanvas()
    //   this.drewChess(this.Chess)
    // }
  },
  // 2 销毁这个监听事件
  destroyed () {
    // 销毁这个监听事件，需要找到这个函数，如果使用的是匿名函数的话，无法查找这个函数，这个事件也就没有办法被移除 ，在其他页面仍然会执行这个监听事件
    window.removeEventListener('beforeunload', this.unload)
  },
  methods: {
    unload (e) {
      e = e || window.event
      if (e) {
        console.log(e)
        // 在这里阻止默认的刷新，弹出弹框
        e.returnValue = '重新加载将导致准考证号失效，是否重新加载'
        // return '重新加载将导致准考证号失效，是否重新加载'
      }
      return '重新加载将导致准考证号失效，是否重新加载'
    },
    // 获取闯关题
    getTest (id, exchangCode) {
      getWalkingEnrollItemBank({
        enrollGradeId: id,
        exchangCode: exchangCode
      }).then(res => {
        // success
        console.log('13级', res)
        if (res.success) {
          this.$message({
            message: '已刷新，准考证号失效将退出本次考试',
            center: true,
            type: 'warning'
          })
          setTimeout(() => {
            this.$router.push('/gradingTest')
          }, 3000)
        } else {
          res.walkingEnrollItemBanks.gradId = this.gradId
          res.walkingEnrollItemBanks.levelexam = this.levelexam
          this.walkingEnrollItemBanks = res.walkingEnrollItemBanks
          console.log('this.walkingEnrollItemBanks', this.walkingEnrollItemBanks)
          this.total = res.walkingEnrollItemBanks.length
          this.isShow = true
        }
      }).catch(() => {
        // console.log('取消')
      })
    },
    // 提交闯关结果
    updateEnrollFractionById (fraction) {
      updateEnrollFractionById({
        id: this.gradId,
        fraction: fraction
      }).then(res => {
        // success
        console.log(res)
        this.$router.push({
          name: 'gradingResults',
          // name: 'mallList',
          query: {
            id: this.gradId,
            fractions: fraction,
            levelexam: this.levelexam
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    pgochessnum (num) {
      this.success = num
      console.log(this.success, 'this.this.success')
    },
    pgochestest (event) {
      this.testIndex = event
      console.log(event, 'this.testIndex')
    },
    submit () {
      this.$confirm('确认交卷', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        // console.log(this.selects)
        // console.log(sum)
        // let totalNumber = this.success * 5
        this.updateEnrollFractionById(this.success)
      }).catch(() => {
        // console.log('取消')
        // this.$confirm('将退出答题页面，本次考试将作废', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   center: true
        // }).then(() => {
        // // console.log(this.selects)
        // // console.log(sum)
        //   this.$router.push('/gradingTest')
        // }).catch(() => {
        // // console.log('取消')
        //   // let totalNumber = this.success * 5
        //   this.updateEnrollFractionById(this.success)
        // })
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/base.scss";
  @import "../../assets/scss/mixin.scss";
  @import "../../assets/scss/config.scss";
  .container{
    box-sizing: border-box;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .dotest{
      box-sizing: border-box;
      height: 40px;
      width: 100%;
      border-bottom: 1px solid #cecece;
      @include flex();
      margin-top: 30px;
      .left{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #EF0404;
      }
      .right{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        .time{
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #EF0404;
        }
      }
    }
    .dotest_content{
      box-sizing: border-box;
      margin-top: 40px;
      margin-bottom: 90px;
      @include flexed();
      .item_left{
        width: 225px;
        margin-right: 24px;
        .info{
          width: 225px;
          border: 1px solid #cecece;
          padding: 20px 30px;
          box-sizing: border-box;
          margin-bottom: 20px;
          .item_title{
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
          .item_info{
            width: 100%;
            text-align: left;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin: 10px 0;
            .question{
              color: #000;
              font-size: 30px;
            }
            .success{
              color: #EF0404;
              font-size: 30px;
            }
          }
        }
        .select {
          width: 225px;
          border: 1px solid #cecece;
          padding: 10px 30px 20px;
          box-sizing: border-box;
          @include flexed();
          .item_choose{
            cursor: not-allowed;
            width: 20px;
            height: 20px;
            border: 1px solid #cecece;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            text-align: center;
            line-height: 20px;
            margin-top: 10px;
            margin-right: 13px;
            &:nth-child(5n){
              margin-right: 0;
            }
          }
          .item_chooses{
            background-color: #008DE9;
            border: 1px solid #008DE9;
            color: #ffffff;
          }
          .agin_item_choose {
            background-color: #999;
            border: 1px solid #999;
            color: #000;
          }
        }
        .submit{
            width: 100px;
            height: 40px;
            background-color: #008DE9;
            color: #ffffff;
            text-align: center;
            line-height: 40px;
            font-size: 20px;
            margin: auto;
            margin-top: 50px;
            cursor: pointer;
          }
      }
      .item-rigts{
        width: 931px;
        border: 1px solid #cecece;
        padding-top: 20px;
        padding-bottom: 20px;
        // padding-left: 59px;
        box-sizing: border-box;
        margin: auto;
        .canvas-bg{
          width: 480px;
          background-color: #f8be7c;
          padding: 20px;
          margin: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/grading_test/gochess.vue